import './moment-locale-es'

import moment from 'moment-timezone'

import { MONTH_NAMES_LONG, MONTH_NAMES_SHORT } from '../constants'

const DATE_UNITS = {
    HOUR: 'hours',
    DAY: 'days',
    MONTH: 'months',
    YEAR: 'years',
}

const dateFormat = 'YYYY-MM-DD'

export const getStringDate = (date = getDate()) => getDate(date).format(dateFormat)

export const getDate = (date = moment()) => moment(date, dateFormat)

export const getYear = (date = getDate()) => getDate(date).year()

export const getMonth = (date = getDate()) => getDate(date).month() + 1

export const getCurrentYear = () => getYear()

const addDate =
    (unit) =>
    (days) =>
    (date = getDate()) =>
        getDate(date).add(days, unit)
const subtractDate =
    (unit) =>
    (days) =>
    (date = getDate()) =>
        getDate(date).subtract(days, unit)

export const addDays = addDate(DATE_UNITS.DAY)
export const subtractDays = subtractDate(DATE_UNITS.DAY)
export const addMonths = addDate(DATE_UNITS.MONTH)

export const getMonthName = (date = getDate()) => getDate(date).format('MMMM')

export const getDateInMonth = (month) => `2000-${month}-01`

export const getIsDateExceeded = (
    date = getDate(),
    dateToCompare = getDate(),
    { unit = 'days', inclusive = false } = {}
) =>
    inclusive
        ? moment(date, dateFormat).isSameOrAfter(moment(dateToCompare, dateFormat), unit)
        : moment(date, dateFormat).isAfter(moment(dateToCompare, dateFormat), unit)

export const getIsWeekend = (date = getDate()) => {
    const day = moment(date).day()
    return [6, 0].includes(day)
}

export const formatDate = (dateTimeUTC) => {
    const date = new Date(dateTimeUTC)
    const month = MONTH_NAMES_SHORT[date.getMonth()]
    return `${date.getDate()} ${month} ${date.getFullYear()}`
}

export const formatDateLong = (dateTimeUTC) => {
    const date = new Date(dateTimeUTC)
    const month = MONTH_NAMES_LONG[date.getMonth()]
    return `${date.getDate()} de ${month} de ${date.getFullYear()}`
}

export const formatDateDayAndMonth = (dateTimeUTC) => {
    const date = new Date(dateTimeUTC)
    const month = MONTH_NAMES_LONG[date.getMonth()]
    return `${date.getDate()} de ${month}`
}

export const formatTimePeriod = (dateTimeUTC, durationInMinutes) => {
    const date = moment.tz(moment.utc(dateTimeUTC), 'Europe/Madrid')
    const endDate = date.clone().add(durationInMinutes, 'minute')
    return `${date.format('HH:mm')} a ${endDate.format('HH:mm')}`
}

export const formatTaxYearDateRange = (taxYear) => `1 de enero - 31 de diciembre de ${taxYear}`

export const formatDateWithTime = (dateTimeUTC) => {
    if (!dateTimeUTC) return null
    return moment.tz(moment.utc(dateTimeUTC), 'Europe/Madrid').format('D MMM YYYY HH:mm')
}

export const formatDateFromNow = (dateTimeUTC) => moment.utc(dateTimeUTC).fromNow()

export const getDaysUntilDate = ({ start = new Date(), end }) =>
    Math.ceil((end.getTime() - start.getTime()) / 1000 / 60 / 60 / 24)
